'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenError = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullScreenError = exports.FullScreenError = function FullScreenError(props) {
  var content = void 0;
  var _props$error = props.error,
      message = _props$error.message,
      code = _props$error.code;


  if (code && code === 404) {
    content = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h1',
        { className: 'title' },
        '404'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Whoops!',
        _react2.default.createElement('br', null),
        'That\u2019s not how we wanted this to go.'
      )
    );
  } else {
    content = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h2',
        { className: 'title' },
        'We are a bit busy right now!'
      ),
      _react2.default.createElement(
        'p',
        null,
        'We\u2019re doing some heavy lifting at the moment.',
        _react2.default.createElement('br', null),
        'Check back soon!'
      )
    );
  }

  return _react2.default.createElement(
    _reactBodyClassname2.default,
    { className: 'body--error body--no-footer body--render-error' },
    _react2.default.createElement(
      'div',
      { className: 'render-error' },
      _react2.default.createElement('img', { className: 'render-error__arm', src: require('../../../static/img/404-arm.png'), alt: 'Arm', width: '599', height: '548' }),
      _react2.default.createElement('img', { className: 'render-error__kettlebell', src: require('../../../static/img/404-weight.png'), alt: 'Weight', width: '654', height: '464' }),
      _react2.default.createElement(
        'section',
        { className: 'render-error__content' },
        content,
        _react2.default.createElement(
          'div',
          { className: 'hidden', 'data-code': code },
          message
        )
      )
    )
  );
};

FullScreenError.propTypes = {
  error: _propTypes2.default.shape({
    message: _propTypes2.default.string.isRequired,
    details: _propTypes2.default.string,
    code: _propTypes2.default.number
  }).isRequired
};